import Swiper from 'swiper';

const getNav = (node) => ({
    nextEl: node.querySelector('.nav.nav--next'),
    prevEl: node.querySelector('.nav.nav--prev')
});

const getPagination = (node) => node.querySelector('.pagination-wrap');

const initSwiper = (node, isMobile) => {
    const { nextEl, prevEl } = getNav(node);

    const swiperInstance = new Swiper(node, {
        speed: 600,
        spaceBetween: 100,
        grabCursor: true,
        navigation: !isMobile && {
            nextEl,
            prevEl,
            hiddenClass: 'swiper-button-disabled'
        },
        pagination: {
            el: getPagination(node),
            clickable: !isMobile
        },
        observer: true,
        observeParents: true
    });

    return swiperInstance;
};

export const initSliders = (isMobile = false) => {
    const slidersNodeList = document.querySelectorAll('.okko-slider');

    slidersNodeList.forEach((node) => initSwiper(node, isMobile));
};
